import React, { useRef } from 'react';
import { Check } from 'lucide-react';

const ClosedQuestion = ({ question, value, onChange, labelledBy }) => {
  const listRef = useRef(null);

  const moveFocus = (event, index) => {
    const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
    if (!(event.key in keys)) return;
    event.preventDefault();
    const count = question.options.length;
    const next = (index + keys[event.key] + count) % count;
    const buttons = listRef.current ? listRef.current.querySelectorAll('button') : [];
    if (buttons[next]) buttons[next].focus();
    onChange(question.options[next]);
  };

  const selectedIndex = question.options.findIndex((option) => option === value);

  return (
    <div ref={listRef} className="tp-answer__options" role="radiogroup" aria-labelledby={labelledBy}>
      {question.options.map((option, index) => {
        const selected = value === option;
        const focusable = selectedIndex === -1 ? index === 0 : selected;
        return (
          <button
            key={`${question.id}-${index}`}
            type="button"
            role="radio"
            aria-checked={selected}
            tabIndex={focusable ? 0 : -1}
            className={`tp-answer__option ${selected ? 'is-selected' : ''}`.trim()}
            onClick={() => onChange(option)}
            onKeyDown={(event) => moveFocus(event, index)}
          >
            <span className="tp-answer__option-mark" aria-hidden="true">
              {selected && <Check size={14} strokeWidth={3} />}
            </span>
            <span className="tp-answer__option-label">{String(option).trim()}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ClosedQuestion;
